import { MenuItem, PrimeIcons } from "primeng/api";
import { AbstractMenuModule } from "../menu/abstract-menu-module";
import { ClientInfoModel, CargoFeaturesModel, AuthUserModel } from "../model";

const _menuItems: MenuItem[] = [
  {
    id: 'shipments',
    label: 'Отправка',
    icon: PrimeIcons.SEND,
    routerLink: 'adminPanel/shipments',
    visible: false,
  },
  {
    id: 'consolidations',
    label: 'Консолидации',
    icon: 'pi pi-fw pi-calendar',
    routerLink: 'adminPanel/consolidations',
    visible: false
  },
  {
    id: 'received',
    label: 'Приход',
    icon: PrimeIcons.TRUCK,
    routerLink: 'adminPanel/received'
  },
  {
    id: 'clients',
    label: 'Клиенты',
    icon: PrimeIcons.USERS,
    items: [
      {
        id: 'track_check',
        label: 'Проверка номеров',
        icon: PrimeIcons.CHECK_CIRCLE,
        routerLink: 'adminPanel/clients'
      },
      {
        id: 'package_delivery',
        label: 'Выдача посылок',
        icon: PrimeIcons.DIRECTIONS,
        routerLink: 'adminPanel/clients/delivery'
      },
      {
        id: 'clientsList',
        label: 'Список клиентов',
        icon: PrimeIcons.ID_CARD,
        routerLink: 'adminPanel/clients/clientData'
      },

    ],
  },
  {
    id: 'reporting',
    label: 'Отчетность',
    icon: 'pi pi-chart-line',
    visible: false,
    items: [
      {
        id: 'dailyStatReport',
        label: 'Статистика за день',
        icon: PrimeIcons.TABLE,
        routerLink: 'adminPanel/reporting'
      },
      {
        id: 'dailyDistributionReport',
        label: 'Распределение за день',
        icon: PrimeIcons.CHART_BAR,
        routerLink: 'adminPanel/reporting/distribution'
      },
    ],
  },
];

export class AdminPanelMenu extends AbstractMenuModule {
  override checkUserRole(roleName?: string): boolean {
    return roleName === 'admin' || roleName === 'storeman';
  }
  
  override buildMenu(user?: ClientInfoModel, auth?: AuthUserModel, features?: CargoFeaturesModel): MenuItem[] {
    const menuItems = this.copyMenuItems(_menuItems);

    menuItems.forEach((item: MenuItem) => {
      if (item.id === 'consolidations' && features?.isConsolidationsEnabled) {
        item.visible = true;
      }

      if (item.id === 'shipments' && auth?.userRole === 'admin') {
        item.visible = true;
      }

      if (item.id === 'reporting' && auth?.userRole === 'admin') {
        item.visible = true;
      }

      if (item.id === 'clients') {
        // allow clients list for admin only

        const clientsListItem = item.items?.find((value, index, obj) => {
          return value.id === 'clientsList'
        });
        // _.find(item.items , { id: 'clientsList' });

        if (clientsListItem) {
          clientsListItem.visible = auth?.userRole === 'admin'
        }
      }
    });

    return menuItems;
  }

}

